import Text from '../../Text'
import { ChartItemLabel } from '../ChartItemLabel'

import * as styles from './ChartLegend.module.css'

function ChartLegend({ className = styles.legend, items }) {
  return (
    <ul className={className}>
      {items.map(item => (
        <li className={styles.item} key={item.id}>
          <span
            className={styles.dot}
            style={{ backgroundColor: item.color }}
          />
          <ChartItemLabel text={item.label} />
          {item.value ? (
            <Text isSecondary className={styles.value}>
              {item.value}
            </Text>
          ) : null}
        </li>
      ))}
    </ul>
  )
}

export default ChartLegend
